'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Pagination = require('./Pagination');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Pagination)['default'];
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rc-pagination/lib/index.js
// module id = 1763
// module chunks = 0